import { render, staticRenderFns } from "./trainingModulePageInformationImage1.vue?vue&type=template&id=73957a58&scoped=true&"
import script from "./trainingModulePageInformationImage1.vue?vue&type=script&lang=js&"
export * from "./trainingModulePageInformationImage1.vue?vue&type=script&lang=js&"
import style0 from "./trainingModulePageInformationImage1.vue?vue&type=style&index=0&id=73957a58&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73957a58",
  null
  
)

export default component.exports